import { render, staticRenderFns } from "./OrganizationVariableConfigForm.vue?vue&type=template&id=298f5119&scoped=true&"
import script from "./OrganizationVariableConfigForm.vue?vue&type=script&lang=js&"
export * from "./OrganizationVariableConfigForm.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationVariableConfigForm.vue?vue&type=style&index=0&id=298f5119&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298f5119",
  null
  
)

export default component.exports